import { render, staticRenderFns } from "./CentralMember.vue?vue&type=template&id=08dfb6bc&scoped=true"
import script from "./CentralMember.vue?vue&type=script&lang=js"
export * from "./CentralMember.vue?vue&type=script&lang=js"
import style0 from "./CentralMember.vue?vue&type=style&index=0&id=08dfb6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dfb6bc",
  null
  
)

export default component.exports